module.exports = __webpack_public_path__ + "03_mole.2c5eb71a.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/momoro/mama/layer3/03_mole.png
// module id = KtEj
// module chunks = 0